<template>
    <div class="school-detail-wraper">
        <div class="card-top">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="detail-top">
            <div class="top-logo">
                <img :src="detail.logo" alt="院校logo" width="100%">
            </div>
            <div class="top-mid">
                <div class="mid-school-name">
                    <h3>{{ detail.yxmc }}</h3>
                    <el-button  type="primary" size="mini" plain round @click="closeWin">关闭</el-button>
                </div>
                <div class="mid-school-nature">
                    <div class="nature-item">
                        <span>院校地址：{{detail.dz}}</span>
                    </div> 
                    <div class="nature-item">
                        <span class="school-link" @click="schoolLink(detail.wz)">网址：{{detail.wz}}</span>
                    </div>
                </div>
            </div>
            <div></div>
        </div>
        <div class="detail-main">
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="院校简介" name="intro">
                    <div v-if="detail.jbxx"><div class="yxjj"  v-html="detail.jbxx" ></div></div>
                    <div class="yxjj" v-else>暂无信息</div>
                </el-tab-pane>
                <el-tab-pane label="招生简章" name="zsjz">
                    <div class="zsjz" v-if="detail.zsjz" v-html="detail.zsjz"></div>
                    <div class="zsjz" v-else>招生简章持续更新中敬请期待。。。</div>
                </el-tab-pane>
                <!-- <el-tab-pane label="录取详情" name="detail">
                    <div class="item-zyjs">
                        <div class="item-title">
                            <label>院校+专业组计划数</label>
                        </div>
                        <div class="info-data-wrap">
                            <table class="info-data">
                                <tr>
                                    <th width="5%">年度</th>
                                    <th>专业名称</th>  
                                    <th>专业组</th>
                                    <th>专业类别</th>  
                                    <th>招生批次</th>
                                    <th>计划数</th>  
                                    <th>再选科目要求</th>
                                    <th>学制</th>  
                                    <th>收费标准</th>
                                </tr>
                                <tr v-if="yxZyzPlan.length === 0"> <td colspan="9">暂无数据</td></tr>
                                <tr v-for="(planB,index) in yxZyzPlan" :key="index">
                                    <td>{{ planB.nd }}</td>
                                    <td>{{ planB.zymc }}</td>
                                    <td>{{ planB.zyz }}</td>
                                    <td>{{ planB.zylb }}</td>
                                    <td>{{ planB.pc }}</td>
                                    <td>{{ planB.jhs }}</td>
                                    <td>{{ planB.zxkmyq }}</td>
                                    <td>{{ planB.xz }}</td>
                                    <td>{{ planB.xf }}</td>
                                </tr>
                            </table>
                        </div>
                    </div> 
                    <div class="item-zyjs">
                        <div class="item-title">
                            <label>在湘投档线</label>
                        </div>
                        <div class="info-data-wrap">
                            <div class="enrollContainer" >
                                <el-table :data="tdxList" border max-height="500" empty-text size="small" >
                                    <el-table-column align="center" prop="nd" label="年度" ></el-table-column>
                                    <el-table-column align="center" prop="pc" label="批次"></el-table-column>
                                    <el-table-column align="center" prop="zyz" label="专业组"></el-table-column>
                                    <el-table-column align="center" prop="tdx" label="投档线"></el-table-column>
                                    <el-table-column align="center" prop="equivalent" label="我的成绩"></el-table-column>
                                    <el-table-column align="center" prop="minWhcj" label="最低文化成绩"></el-table-column>
                                    <el-table-column align="center" prop="minZycj" label="最低专业成绩"></el-table-column>
                                    <el-table-column align="center" prop="kl" label="科类"></el-table-column>
                                    <el-table-column align="center" prop="lb" label="专业类别"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                    <div class="item-zyjs">
                        <div class="item-title">
                            <label>录取数据</label>
                        </div>
                        <div class="info-data-wrap">
                            <div class="enrollContainer" >
                                <el-table :data="lqsj" max-height="500" empty-text size="small">
                                    <el-table-column align="center"  width="50" prop="nd" label="年度" ></el-table-column>
                                    <el-table-column align="center" width="90" prop="pc" label="批次"></el-table-column>
                                    <el-table-column align="center" width="60" prop="minWh" label="最低文化成绩"></el-table-column>
                                    <el-table-column align="center" label="专业成绩">
                                        <el-table-column align="center" width="60" prop="minZy" label="最低"></el-table-column>
                                        <el-table-column align="center" width="60" prop="rankZy" label=排名></el-table-column>
                                    </el-table-column>
                                    <el-table-column align="center" label="综合成绩">
                                        <el-table-column align="center" width="60" prop="minZh" label="最低"></el-table-column>
                                        <el-table-column align="center" width="60" prop="avgZh" label=平均></el-table-column>
                                        <el-table-column align="center" width="60" prop="maxZh" label=最高></el-table-column>
                                    </el-table-column>
                                    <el-table-column align="center" prop="kl" width="60" label="科目"></el-table-column>
                                    <el-table-column align="center" prop="zymc" width="120" label="专业名称"></el-table-column>
                                    <el-table-column align="center" prop="zylb" width="80" label="专业类别"></el-table-column>
                                    <el-table-column align="center" prop="bz" label="备注"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                    <div class="item-zyjs">
                        <div class="item-title">
                            <label>录取规则</label>
                            <div style="width:150px;">
                                <el-select v-model="MaxValueLq" @change="changeLqNd">
                                    <el-option
                                    v-for="item in detail.list"
                                    :key="item.id"
                                    :label="item.nd"
                                    :value="item.nd">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info-data-wrap" v-for="(item,index) in lqDetail" :key="index">
                            <div class="item-title-enroll">
                                <div v-if="item.lqxq">
                                    <p v-html="item.lqxq"></p>
                                </div>
                                <div v-else>暂无信息，请点击其它年度查看录取规则</div>
                            </div> 
                        </div>
                    </div>
                    <div class="item-zyjs">
                        <div class="item-title">
                            <label>院校专业计划数</label>
                             <div style="width:150px;">
                                <el-select v-model="MaxValueJh" @change="changeJh">
                                    <el-option
                                    v-for="(item,index) in jhndList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info-data-wrap">
                            <table class="info-data">
                                <tr>
                                    <th width="5%">年度</th>
                                    <th>专业名称</th>  
                                    <th>专业类别</th>  
                                    <th>招生批次</th>
                                    <th>计划数</th>  
                                    <th>学制</th>  
                                    <th>收费标准</th>
                                </tr>
                                <tr v-for="(zyJhs,index) in lqjsDetali" :key="index">
                                    <td>{{ zyJhs.nd }}</td>
                                    <td>{{ zyJhs.zymc }}</td>
                                    <td>{{ zyJhs.zylb }}</td>
                                    <td>{{ zyJhs.pc }}</td>
                                    <td>{{ zyJhs.jhs }}</td>
                                    <td>{{ zyJhs.xz }}</td>
                                    <td>{{ zyJhs.xf }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </el-tab-pane> -->
                <el-tab-pane label="招生章程" name="zszc">
                    <div class="zsjz" v-if="detail.zszc" v-html="detail.zszc"></div>
                    <div class="zsjz" v-else>招生章程持续更新中敬请期待。。。</div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import {getSchoolDetail} from '../../api/index'
import {mapState} from 'vuex'
    export default {
        name:"SchoolDetail",
        data() {
            return {
                detail: "",
                activeName: "intro",
                MaxValueLq: '',// 默认选择最大年度-录取详情
                MaxValueJh: '',// 默认选择最大年度-院校专业计划数
                jhndList: [],// 计划数年度集合
                lqDetail: [], // 录取规则
                lqjsDetali: '', // 录取计划
                lqsj: [], // 录取数据
                tdxList: [], // 投档线数据
                module:{},
                yxZyzPlan: [] // 院校专业组计划数据
            }
        },
     
        methods: {
            // 初始化数据院校详情数据
            async _initSchoolDetail() {
                let { item, zyz = null,pc } = this.$route.query;
                // const result = await getSchoolDetail(item,zyz);
                const result = await this.module.getSchoolDetail(item,zyz,pc);
                if(result.data.code === 200){
                    this.detail = result.data.data;
                    this.lqsj = result.data.data.lqsj;
                    this.tdxList = result.data.data.tdx;
                    this.yxZyzPlan = result.data.data.yxZyzPlan;
                    let ndList = result.data.data.list; 
                    let zyjhs = result.data.data.listPlan;
                    let arrNd = [];
                    let arrzyjhs = [];
                    ndList.map((item,i)=>{ arrNd.push(item.nd); });
                    zyjhs.map((item,i)=>{
                        arrzyjhs.push(item.nd);
                    });
                    this.jhndList = Array.from(new Set(arrzyjhs))
                    let MaxNdLq = Math.max(...arrNd);
                    if(MaxNdLq === -Infinity) {
                       this.MaxValueLq = '暂无数据'
                    }else {
                        this.MaxValueLq = MaxNdLq
                    }
                    this.lqDetail = ndList.filter((o)=>{
                        return o.nd ==  this.MaxValueLq
                    })
                    let MaxValueJhOne = Math.max(...arrzyjhs);
                    if(MaxValueJhOne === -Infinity) {
                        this.MaxValueJh = '暂无数据'
                    }else {
                        this.MaxValueJh = MaxValueJhOne
                    }    
                    this.lqjsDetali = zyjhs.filter((o)=>{
                        return o.nd ==  Math.max(...arrzyjhs);
                    });
                }else if(result.data.code===500){
                    if(result.data.message){
                        this.$message({message:result.data.message,type:'error'});
                    }else if(result.data.msg){
                    this.$message({message:result.data.message,type:'error'});
                    }
                }else if(result.status===401){
                        this.$message({message: '登录超时，请重新登录',type:"error"});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
                }else if(result.data.code===0){
                        this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
                }else if(result.status===409||result.status===410||result.status===411){
                        this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                        await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                        this.$router.replace({
                            path: '/main/home',
                            query: {redirect: this.$router.currentRoute.fullPath}
                        });
                }
            },
            //关闭当前页面
            closeWin() {
                let userAgent = navigator.userAgent;
                if (userAgent.indexOf("Firefox") !== -1 || userAgent.indexOf("Chrome") !== -1) {
                    window.open('','_self').close()  
                }else {   
                    window.opener = null;
                    window.open("about:blank", "_self");
                    window.close();
                }
            },
            //切换录取详情年度
            changeLqNd(nd) {
                let temp = this.detail.list;
                this.lqDetail = temp.filter((o)=>{
                    return o.nd == nd
                });
            },
            async getApiIndexMethod(){
                const flag=this.$apiFlag;
                if(flag===1||flag===3){
                    this.module=await import("../../api/index");
                }else if(flag===2){
                    this.module=await import("../../api/index22");
                }
            },
            changeJh(nd) {
                let temp = this.detail.listPlan;
                this.lqjsDetali = temp.filter((o)=>{
                    return o.nd == nd
                });
            },
            //打开学校官网链接
            schoolLink(schoolUrl) {
                window.open(schoolUrl,"_blank")
            },
        },
        async mounted() {
            this.$store.commit('initIsUpdateToken');
            await this.getApiIndexMethod();
            await this._initSchoolDetail();
        },
    }
</script>

<style lang="stylus" scoped>
.school-detail-wraper
    min-width 1100px
    margin 0 auto
    min-height calc(100vh - 380px)
    min-height -moz-calc(100vh - 380px)
    min-height -webkit-calc(100vh - 380px) 
    .card-top
        width 1100px
        margin 20px auto
    .detail-top
        display flex
        align-items center
        width 1100px
        margin 0 auto  
        padding 20px 0 
        background-color #fff
        .top-logo
            width 80px
            height 80px 
            box-sizing border-box
            margin 0 30px
        .top-mid
            width 80%
            box-sizing border-box
            color #666   
            .mid-school-name
                display flex
                justify-content space-between
                margin-bottom 10px
                font-size 18px
                color #333 
            .mid-school-nature
                display flex
                font-size 14px    
                .nature-item
                    flex 1
                    .school-link
                        cursor pointer
                    .school-link:hover
                        color #409EFF
    .detail-main
        box-sizing border-box
        width 1100px
        margin 0 auto  
        padding 20px 30px
        background-color #fff  
        .yxjj,.zsjz
            width 1000px
            margin 20px auto 0
            font-size 14px
            color #666
            line-height 30px
        .item-zyjs
           margin 20px 0   
           .item-title 
                   display flex
                   justify-content space-between
                   height 30px
                   line-height 30px
                   padding-left 10px
                   border-left 4px solid #409EFF
                   font-size 20px
                   font-weight 600
                   color #333
            .info-data-wrap  
                    width 100%  
                    margin: 20px auto 0
                    padding-top 15px
                    font-size 14px
                    color #666
                    line-height 30px
                    border-top 1px solid #eaeaea
                    .info-data
                        width 100%
                        color #666
                        font-size 14px
                        th
                            box-sizing border-box
                            border 1px solid #DCDFE6
                            padding 1px 0
                            text-align center
                            background-color #f8f8f9
                        td
                            box-sizing border-box
                            padding 1px 5px
                            border 1px solid #DCDFE6
                            text-align center    
                            color #606266
                            font-size 12px 
                    .item-title-enroll
                        display flex
                        flex-direction column       
                        .enroll-title
                            height 30px
                            line-height 30px
                            padding-left 10px
                            border-left 4px solid #409EFF
                            font-size 20px
                            font-weight 600
                            color #333 
                        .enrollContainer
                            max-height 500px
                            margin-top 20px
                            overflow-y scroll
                            .image-slot
                                margin-top 30px
                                font-size 16px
                                font-weight 600
                                color #333
</style>
<style scoped>

h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
a{
    color:#333 !important;
}
</style>